import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取验证码
  getVerification(data) {
    const params = data
    return request({
      url: urlParams + '/verification/tr/getCode',
      type: 'get',
      params: params
    })
  },
  // 登录
  loginIn(data) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/login',
      type: 'post',
      params: params
    })
  },
  // 获取菜单数据
  getMenuData(data) {
    const params = data
    return request({
      url: urlParams + '/menu/nav',
      type: 'get',
      params: params
    })
  },
   // 上传图片
   verificationImg(data) {
    const params = data
    return request({
      url: urlParams + '/verification/img',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
   // 上传文件
   verificationFile(data) {
    const params = data
    return request({
      url: urlParams + '/verification/file',
      type: 'post',
      params: params,
      qs:false
    })
  },   
}
